import {
  SET_FAVORITE_LIST,
  RESET_FAVORITE_LIST,
  SET_ORDER_LIST,
  RESET_ORDER_LIST,
  SET_ADDRESS_LIST,
  RESET_ADDRESS_LIST,
} from '../mutation-types';

export default {
  [SET_FAVORITE_LIST](state, payload) {
    state.favoriteList = payload;
  },
  [RESET_FAVORITE_LIST](state) {
    state.favoriteList.status = 0;
  },
  [SET_ORDER_LIST](state, payload) {
    state.orderList[payload.target] = payload.data;
  },
  [RESET_ORDER_LIST](state, payload) {
    state.orderList[payload].status = 0;
  },
  [SET_ADDRESS_LIST](state, payload) {
    state.addressList = payload;
  },
  [RESET_ADDRESS_LIST](state) {
    state.addressList.status = 0;
  },
};
